import { render } from "./MainMenuItem.vue?vue&type=template&id=c73edfa6&scoped=true&ts=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=ts"
export * from "./MainMenuItem.vue?vue&type=script&lang=ts"

import "./main-menu.scss?vue&type=style&index=0&id=c73edfa6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73edfa6"]])

export default __exports__